import React from "react";
import "./App.css";
import LoginPage from "./components/LoginPage";
import RegisterPage from "./components/RegisterPage";
import ToolsPage from "./components/ToolsPage";
import { useAuth } from "./auth/AuthContext";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import config from "./config";

function App() {
  const {
  auth,
  authReady,
  login,
  logout,
  refreshSession,
  clearSession,
  isAuthenticated,
} = useAuth();

  const navigate = useNavigate();

React.useEffect(() => {
  const handler = () => {
    try {
      sessionStorage.setItem("aei_login_message", "SESSION_EXPIRED");
      sessionStorage.removeItem("aei_portal_access_token");
      localStorage.setItem("aei_portal_logout_at", String(Date.now()));
    } catch (err) {
      console.warn("Could not clear browser session after expiry:", err);
    }

    clearSession({ markLogout: true });
    navigate("/login", { replace: true });
  };

  window.addEventListener("aei:session-expired", handler);
  return () => window.removeEventListener("aei:session-expired", handler);
}, [clearSession, navigate]);

  if (!authReady) {
    return <div style={{ padding: 20 }}>Loading...</div>;
  }

 const handleLoginSuccess = async (authPayload) => {
  try {
    await login(authPayload);
    navigate("/tools", { replace: true });
  } catch (err) {
    console.error("Post-login refresh failed:", err);
    clearSession();
    navigate("/login", { replace: true });
  }
};

  const goToRegister = () => {
    navigate("/register", { replace: true });
  };

  const goToLogin = () => {
    navigate("/login", { replace: true });
  };

  const ensurePortalSession = async () => {
    try {
      await refreshSession();
      return true;
    } catch (err) {
      console.warn("Portal session check failed:", err);
      navigate("/login", { replace: true });
      return false;
    }
  };

  const openStripforces = async () => {
    const ok = await ensurePortalSession();
    if (!ok) return;

  const url = config.stripforcesUrl;

   if (!url) {
  console.error("Stripforces URL is not configured.");
  return;
}

console.log("Portal opening Stripforces:", url);
window.location.href = url;
  };

  const openTimeTracker = async () => {
    const ok = await ensurePortalSession();
    if (!ok) return;

  const url = config.timeTrackerUrl;

    if (!url) {
  console.error("Time Tracker URL is not configured.");
  return;
}

console.log("Portal opening Time Tracker:", url);
window.location.href = url;
  };

const openSap2000 = async () => {
  try {
    const refreshedAuth = await refreshSession();

    const url = config.sap2000Url;

    if (!url) {
      console.error("SAP2000 URL is not configured.");
      return;
    }

    const accessToken =
      refreshedAuth?.accessToken ||
      refreshedAuth?.access_token ||
      auth?.accessToken;

    if (!accessToken) {
      console.error("SAP2000 cannot be opened because portal access token is missing.");
      navigate("/login", { replace: true });
      return;
    }

    const cleanUrl = url.replace(/\/$/, "");
const sapUrlWithToken = `${cleanUrl}/#access_token=${encodeURIComponent(
  accessToken
)}`;



try {
  localStorage.removeItem("aei_portal_logout_at");
} catch (err) {
  console.warn("Could not clear logout marker before opening SAP2000:", err);
}

window.location.href = sapUrlWithToken;
  } catch (err) {
    console.warn("Portal session check failed:", err);
    navigate("/login", { replace: true });
  }
};

 const handleLogout = async () => {
  await logout();

  try {
    sessionStorage.setItem("aei_login_message", "LOGGED_OUT");
    sessionStorage.removeItem("aei_portal_access_token");
    localStorage.setItem("aei_portal_logout_at", String(Date.now()));
  } catch (err) {
    console.warn("Could not clear browser session after logout:", err);
  }

  navigate("/login", { replace: true });
};

  return (
    <Routes>
      <Route
        path="/login"
        element={
          isAuthenticated ? (
            <Navigate to="/tools" replace />
          ) : (
            <LoginPage
              onLogin={handleLoginSuccess}
              onShowRegister={goToRegister}
            />
          )
        }
      />

      <Route
        path="/register"
        element={
          isAuthenticated ? (
            <Navigate to="/tools" replace />
          ) : (
            <RegisterPage onBackToLogin={goToLogin} />
          )
        }
      />

      <Route
        path="/tools"
        element={
          isAuthenticated ? (
           <ToolsPage
  onOpenStripforces={openStripforces}
  onOpenTimeTracker={openTimeTracker}
  onOpenSap2000={openSap2000}
  onLogout={handleLogout}
/>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />

      <Route
        path="/"
        element={
          isAuthenticated ? (
            <Navigate to="/tools" replace />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />

      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default App;
